import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';

export const templateCloudStagingList = document.createElement('template');

templateCloudStagingList.innerHTML = `
  <style>${styleHelpers}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <gz-push-body-layout resizable="right">
            <div slot="push-body-sidenav-title">
                <gz-title id="filtersTitle" class="title" fontSize="11" fontweight="600"></gz-title>
            </div>

            <div slot="push-body-sidenav">
             <cloud-staging-side-bar></cloud-staging-side-bar>
            </div>

            <div slot="push-body-content" class="content">
            <gz-grid-view class="grid-view">
                <div class="header-buttons w-full" slot="grid-header-actions-slot">
                    <div class="d-flex flex-row justify-space-between align-items-center w-full">
                      <gz-tooltip id="grid-title-tooltip" class="grid-title-tooltip" isEllipsis>
                        <gz-title id="grid-title" class="flex-3 grid-title" fontSize="18"></gz-title>
                      </gz-tooltip>
                      <gz-text class="changelog-link" fontsize="12" id="product-changelog-text"></gz-text>
                    </div>
                    <gz-text class="pt-2 subtitle-info-text" fontsize="12" style="max-width: 632px" id="subtitle-info-text"></gz-text>
                </div>
            </gz-grid-view>
            </div>
    </gz-push-body-layout>


  </div>
`;
